import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { motion } from 'framer-motion';
const ButtonLabel = ({ children, labelMessage, labelMessageValues, isInProgress, isInitInProgress })=>{
    const intl = useIntl();
    let label = null;
    if (children) {
        label = children;
    } else if (labelMessage) {
        label = typeof labelMessage === 'object' ? intl.formatMessage(labelMessage, labelMessageValues) : labelMessage;
    }
    if (!label) {
        return null;
    }
    return /*#__PURE__*/ _jsx(motion.div, {
        initial: isInitInProgress ? {
            x: '-100%'
        } : {
            x: 0
        },
        animate: isInProgress ? {
            x: '-100%'
        } : {
            x: 0
        },
        transition: {
            ease: 'easeOut',
            duration: 0.15
        },
        className: "btn__labelWrapper",
        children: label
    });
};
export default /*#__PURE__*/ memo(ButtonLabel);
